import graphqlClient from "@/GQLClient";
import type { FetchPolicy } from "@apollo/client";
import { GraphQLError } from "graphql";
import { GetShiftsQueryDocument } from "@/graphql/generated-types";
import type { WSShiftFragment } from "@/graphql";
import { format } from "date-fns";

const getShifts = async (
  departmentId: string,
  fetchPolicy: FetchPolicy = "no-cache",
): Promise<WSShiftFragment[]> => {
  const today = new Date();
  const response = await graphqlClient.query({
    query: GetShiftsQueryDocument,
    fetchPolicy,
    variables: {
      dateFrom: format(today, "yyyy-MM-dd"),
      dateTo: format(today, "yyyy-MM-dd"),
      timezone: new window.Intl.DateTimeFormat().resolvedOptions().timeZone,
      filter: {
        departments: [departmentId],
      },
    },
  });

  if (response.data.schedule?.shifts) {
    return response.data.schedule.shifts;
  }

  throw new GraphQLError(`api.workSchedule.getShifts`);
};

export default {
  getShifts,
};
